<script>
export default {
  name: 'icon-text',
  props: {
    color: {
      type: String,
      default: '#00A5EE',
    },
  },
}
</script>

<template>
  <svg
    width="32"
    height="21"
    viewBox="0 0 32 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.64706 14.7389L3.87543 20.5706H0L6.59439 0H11.3802L18.0607 20.5706H14.0377L12.1799 14.7389H5.64706V14.7389ZM11.5402 11.897L9.91618 6.82814C9.52249 5.57324 9.178 4.1707 8.88273 2.97732H8.82122C8.51365 4.1707 8.20607 5.59785 7.84929 6.82814L6.2622 11.897H11.5402Z"
      :fill="color"
    />
    <path
      d="M28.6043 20.5707L28.3583 18.9221H28.2721C27.3617 20.0786 25.7993 20.9029 23.88 20.9029C20.8904 20.9029 19.2172 18.7376 19.2172 16.4738C19.2172 12.7214 22.539 10.8268 28.0384 10.8637V10.6176C28.0384 9.64569 27.6447 8.0217 25.0119 8.0217C23.5478 8.0217 22.0222 8.47691 21.0134 9.11666L20.2752 6.68068C21.3702 6.00401 23.3017 5.36426 25.6516 5.36426C30.4129 5.36426 31.7908 8.39079 31.7908 11.6142V16.9906C31.7908 18.3316 31.8523 19.648 31.9999 20.5584H28.6166L28.6043 20.5707ZM28.1122 13.312C25.4548 13.2505 22.9203 13.8287 22.9203 16.0924C22.9203 17.5565 23.8677 18.2332 25.0611 18.2332C26.562 18.2332 27.657 17.2612 27.9892 16.1909C28.0753 15.9202 28.1122 15.6126 28.1122 15.3666V13.3243V13.312Z"
      :fill="color"
    />
  </svg>
</template>
